var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Component } from './Component';
import { EventContextProvider } from './context/event-context';
import { StateProvider } from './context/state-context';
export default function MainPanel(props) {
    var jsonData = props.jsonData, _a = props.onButtonClick, onButtonClick = _a === void 0 ? function () { } : _a, _b = props.onIndicatorButtonClick, onIndicatorButtonClick = _b === void 0 ? function () { } : _b, _c = props.onTextInputClick, onTextInputClick = _c === void 0 ? function () { } : _c, _d = props.onLabelClick, onLabelClick = _d === void 0 ? function () { } : _d, _e = props.canClickIndicator, canClickIndicator = _e === void 0 ? false : _e, content = props.content;
    var _onTextInputClick = function (key) {
        onTextInputClick && onTextInputClick(key);
    };
    var _onIndicatorButtonClick = function (key) {
        onIndicatorButtonClick && onIndicatorButtonClick(key);
    };
    var _onButtonClick = function (key) {
        onButtonClick && onButtonClick(key);
    };
    var _onLabelClick = function (key) {
        onLabelClick && onLabelClick(key);
    };
    return (React.createElement(StateProvider, { value: content },
        React.createElement(EventContextProvider, { value: {
                _onButtonClick: _onButtonClick,
                _onIndicatorButtonClick: _onIndicatorButtonClick,
                _onTextInputClick: _onTextInputClick,
                _onLabelClick: _onLabelClick,
            } },
            React.createElement(Component, __assign({}, jsonData.main, { canClickIndicator: canClickIndicator })))));
}
//# sourceMappingURL=MainPanel.js.map